import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './conditions-text.module.css';

const ConditionsText = () => {
  const [t] = useTranslation();
  return (
    <>
      <p>{t('pages.data.termsAndConditions.welcomeText1')}</p>
      <p>{t('pages.data.termsAndConditions.welcomeText2')}</p>

      <ul>
        <li className={styles.text}>
          <p>{t('pages.data.termsAndConditions.conditionText1')}</p>
        </li>
        <li className={styles.text}>
          <p>{t('pages.data.termsAndConditions.conditionText2')}</p>
        </li>
        <li className={styles.text}>
          <p>{t('pages.data.termsAndConditions.conditionText3')}</p>
        </li>
        <li className={styles.text}>
          <p>{t('pages.data.termsAndConditions.conditionText4')}</p>
        </li>
        <li className={styles.text}>
          <p>{t('pages.data.termsAndConditions.conditionText5')}</p>
        </li>
        <li className={styles.text}>
          <p>{t('pages.data.termsAndConditions.conditionText6')}</p>
        </li>
        <li className={styles.text}>
          <p>{t('pages.data.termsAndConditions.conditionText7')}</p>
        </li>
        <li className={styles.text}>
          <p>{t('pages.data.termsAndConditions.conditionText8')}</p>
        </li>
        <li className={styles.text}>
          <p>{t('pages.data.termsAndConditions.conditionText9')}</p>
        </li>
      </ul>
    </>
  );
};

export default ConditionsText;
